import { Card, Col, Image, message, Row, Spin, Typography } from "antd";
import React from "react";
import {
	IoLinkOutline,
	IoLogoFacebook,
	IoLogoInstagram,
	IoLogoLinkedin,
	IoLogoTwitter,
	IoLogoWhatsapp,
	IoLogoYoutube,
	IoMailOutline,
} from "react-icons/io5";
import TimelineComponent from "../../components/Timeline";
import { getToken, POST_API, POST_CATCH } from "../../services/api";

class WebPerfilSobre extends React.Component {
	state = {
		_params: window.location.href.split("/"),
		profile: null,
		_publicacoes_list: [],
		_publicacoes_loading: true,
		_publicacoes_pagination: {
			current: 1,
			total: 0,
			limit: 30,
		},
		_fotos_list: [],
	};

	componentDidMount = () => {
		this.onView();
		this.onRenderDataPublicacoes();
		this.onRenderDataFotos();
	};

	onRenderDataFotos = () => {
		setTimeout(() => {
			POST_API("/timeline_photo/search.php", {
				token: getToken(),
				filter: JSON.stringify({ CREDENTIAL_ID: this.state._params[4] }),
				pagination: JSON.stringify({ current: 1, total: 0, limit: 4 }),
				type: "list",
			})
				.then((rs) => rs.json())
				.then((res) => {
					if (res.return) {
						this.setState({
							_fotos_list: res.data,
						});
					} else {
						message.error({ content: res.msg, key: "screen" });
					}
				})
				.catch(() => POST_CATCH());
		}, 500);
	};

	onView = async () => {
		await POST_API("/credential/search.php", {
			token: getToken(),
			filter: JSON.stringify({ ID: this.state._params[4] }),
			type: "view",
		})
			.then((rs) => rs.json())
			.then((res) => {
				this.setState({ profile: res.data, _screen: false });
			})
			.catch(() => POST_CATCH());
	};

	onRenderDataPublicacoes = () => {
		this.setState({ _publicacoes_loading: true });
		setTimeout(() => {
			POST_API("/timeline/search.php", {
				token: getToken(),
				filter: JSON.stringify({ CREDENTIAL_ID: this.state._params[4] }),
				pagination: JSON.stringify(this.state._publicacoes_pagination),
				type: "list",
			})
				.then((rs) => rs.json())
				.then((res) => {
					if (res.return) {
						this.setState({
							_publicacoes_list: res.data,
							_publicacoes_pagination: {
								...this.state._publicacoes_pagination,
								total: res.summary.QTDE,
							},
						});
					} else {
						message.error({ content: res.msg, key: "screen" });
					}
				})
				.catch(() => POST_CATCH())
				.finally(() => this.setState({ _publicacoes_loading: false }));
		}, 500);
	};

	onRenderDataPublicacoesLoad = () => {
		setTimeout(() => {
			POST_API("/timeline/search.php", {
				token: getToken(),
				filter: JSON.stringify({ CREDENTIAL_ID: this.state._params[4] }),
				pagination: JSON.stringify(this.state._publicacoes_pagination),
				type: "list",
			})
				.then((rs) => rs.json())
				.then((res) => {
					if (res.return) {
						this.setState({
							_publicacoes_list: res.data,
							_publicacoes_pagination: {
								...this.state._publicacoes_pagination,
								total: res.summary.QTDE,
							},
						});
					} else {
						message.error({ content: res.msg, key: "screen" });
					}
				})
				.catch(() => POST_CATCH())
				.finally(() => this.setState({ _publicacoes_loading: false }));
		}, 500);
	};

	render = () => {
		return (
			<Row className="perfil-content-row" gutter={[16, 16]}>
				<Col md={10} xs={24}>
					<Row gutter={[16, 16]}>
						<Col span={24}>
							<Card title="Apresentação">
								<Typography style={{ textAlign: "justify" }}>
									{this.state.profile?.DESC}
								</Typography>
							</Card>
						</Col>
						<Col span={24}>
							<Card title="Sobre">
								<Typography style={{ textAlign: "justify" }}>
									{this.state.profile?.ABOUT}
								</Typography>
							</Card>
						</Col>
						<Col span={24}>
							<Card title="Contatos">
								{this.state.profile?.EMAIL ? (
									<a
										className="btn-link-contato"
										href={`mailto:${this.state.profile?.EMAIL}`}
										rel="noreferrer"
										target="_blank"
										style={{ textOverflow: "ellipsis", overflow: "hidden" }}
									>
										<IoMailOutline
											size={20}
											style={{ marginRight: 10, minWidth: 20 }}
										/>
										{this.state.profile?.EMAIL}
									</a>
								) : null}
								{this.state.profile?.WHATSAPP ? (
									<a
										className="btn-link-contato"
										href={`https://web.whatsapp.com/send?phone=${this.state.profile?.WHATSAPP}`}
										rel="noreferrer"
										target="_blank"
										style={{ textOverflow: "ellipsis", overflow: "hidden" }}
									>
										<IoLogoWhatsapp
											size={20}
											style={{ marginRight: 10, minWidth: 20 }}
										/>
										{this.state.profile?.WHATSAPP}
									</a>
								) : null}
								{this.state.profile?.FACEBOOK ? (
									<a
										className="btn-link-contato"
										href={`${this.state.profile?.FACEBOOK}`}
										rel="noreferrer"
										target="_blank"
										style={{ textOverflow: "ellipsis", overflow: "hidden" }}
									>
										<IoLogoFacebook
											size={20}
											style={{ marginRight: 10, minWidth: 20 }}
										/>
										{this.state.profile?.FACEBOOK}
									</a>
								) : null}
								{this.state.profile?.INSTAGRAM ? (
									<a
										className="btn-link-contato"
										href={`${this.state.profile?.INSTAGRAM}`}
										rel="noreferrer"
										target="_blank"
										style={{ textOverflow: "ellipsis", overflow: "hidden" }}
									>
										<IoLogoInstagram
											size={20}
											style={{ marginRight: 10, minWidth: 20 }}
										/>
										{this.state.profile?.INSTAGRAM}
									</a>
								) : null}
								{this.state.profile?.TWITTER ? (
									<a
										className="btn-link-contato"
										href={`${this.state.profile?.TWITTER}`}
										rel="noreferrer"
										target="_blank"
										style={{ textOverflow: "ellipsis", overflow: "hidden" }}
									>
										<IoLogoTwitter
											size={20}
											style={{ marginRight: 10, minWidth: 20 }}
										/>
										{this.state.profile?.TWITTER}
									</a>
								) : null}
								{this.state.profile?.LINKEDIN ? (
									<a
										className="btn-link-contato"
										href={`${this.state.profile?.LINKEDIN}`}
										rel="noreferrer"
										target="_blank"
										style={{ textOverflow: "ellipsis", overflow: "hidden" }}
									>
										<IoLogoLinkedin
											size={20}
											style={{ marginRight: 10, minWidth: 20 }}
										/>
										{this.state.profile?.LINKEDIN}
									</a>
								) : null}
								{this.state.profile?.YOUTUBE ? (
									<a
										className="btn-link-contato"
										href={`${this.state.profile?.YOUTUBE}`}
										rel="noreferrer"
										target="_blank"
										style={{ textOverflow: "ellipsis", overflow: "hidden" }}
									>
										<IoLogoYoutube
											size={20}
											style={{ marginRight: 10, minWidth: 20 }}
										/>
										{this.state.profile?.YOUTUBE}
									</a>
								) : null}
								{this.state.profile?.SITE ? (
									<a
										className="btn-link-contato"
										href={`${this.state.profile?.SITE}`}
										rel="noreferrer"
										target="_blank"
										style={{ textOverflow: "ellipsis", overflow: "hidden" }}
									>
										<IoLinkOutline
											size={20}
											style={{ marginRight: 10, minWidth: 20 }}
										/>
										{this.state.profile?.SITE}
									</a>
								) : null}
							</Card>
						</Col>
						<Col span={24}>
							<iframe
								allowfullscreen
								frameborder="0"
								height={400}
								src={`https://maps.google.com/maps?q=${this.state.profile?.STREET} ${this.state.profile?.NUMBER} ${this.state.profile?.DISTRICT} ${this.state.profile?.CITY}&t=&z=13&ie=UTF8&iwloc=&output=embed`}
								title="mapa"
								width={"100%"}
							/>
						</Col>
						<Col span={24}>
							<Card title="Galeria">
								<Row gutter={[4, 4]}>
									{this.state._fotos_list.map((v) => (
										<Col key={v.URL} span={12}>
											<Image className="galeria-image-profile" src={v.URL} />
										</Col>
									))}
								</Row>
							</Card>
						</Col>
					</Row>
				</Col>
				<Col md={14} xs={24}>
					{this.state._publicacoes_loading ? (
						<Col span={24}>
							<center>
								<Spin />
							</center>
						</Col>
					) : (
						<Row gutter={[16, 16]}>
							{this.state._publicacoes_list.length > 0 ? (
								this.state._publicacoes_list.map((item, index) => (
									<Col key={item.ID} span={24}>
										<TimelineComponent
											index={index}
											item={item}
											onActionPublicacoes={this.onActionPublicacoes}
											onRenderDataPublicacoesLoad={
												this.onRenderDataPublicacoesLoad
											}
											openModalPublicacoes={this.openModalPublicacoes}
											type="list"
										/>
									</Col>
								))
							) : (
								<Col span={24}>
									<Typography className="no-data">Sem Publicações</Typography>
								</Col>
							)}
						</Row>
					)}
				</Col>
			</Row>
		);
	};
}

export default WebPerfilSobre;
